import { render } from "./HolwsCastle.vue?vue&type=template&id=1cb9247e"
import script from "./HolwsCastle.vue?vue&type=script&lang=js"
export * from "./HolwsCastle.vue?vue&type=script&lang=js"

import "./HolwsCastle.vue?vue&type=style&index=0&id=1cb9247e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__